"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Guarantee = function () {
    return ((0, preact_1.h)("div", { class: "cart-guarantee" },
        (0, preact_1.h)("p", { class: "cart-guarantee__header" }, "60-Day Money Back Guarantee")));
};
exports.default = Guarantee;
